import { render } from "./TrainingSectionDocumentItem.vue?vue&type=template&id=77a8f976&scoped=true"
import script from "./TrainingSectionDocumentItem.vue?vue&type=script&lang=js"
export * from "./TrainingSectionDocumentItem.vue?vue&type=script&lang=js"

import "./TrainingSectionDocumentItem.vue?vue&type=style&index=0&id=77a8f976&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a8f976"]])

export default __exports__